import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { grey } from '@material-ui/core/colors';
import { FlexFlow } from '../styles/Layout';

const StyledRadioGroup = withStyles({
  root: {
    margin: 0,
    alignSelf: 'stretch',
  },
})(RadioGroup);

const StyledControlLabel = withStyles({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: 'inherit',
    border: '2px solid transparent',
    margin: '0 0 1em',
    minWidth: '2rem',
    minHeight: '2rem',
    padding: '0.05rem',
    transition: 'all 0.3s ease',
    borderRadius: '5px',

    '&.checked': {
      borderColor: grey[400],
      fontWeight: 600,
    },
  },
  label: {
    color: 'inherit',
    fontSize: '0.7rem',
  },
})(FormControlLabel);

const StyledRadio = withStyles({
  root: {
    display: 'none',
  },
})(Radio);

const ContentPicker = ({ items, onChange, selectedItem }) => {
  const [currentValue, setCurrentValue] = useState(selectedItem.value);

  useEffect(() => {
    const { value } = selectedItem;
    setCurrentValue(value);

    return () => {
      setCurrentValue('');
    };
  }, [selectedItem]);

  const handleOnchange = (e, newValue) => {
    const selectItem = items.find((i) => i.value === newValue) || { value: '', item: '' };
    onChange(selectItem);
  };

  return (
    <StyledRadioGroup value={currentValue} onChange={handleOnchange}>
      <FlexFlow splitSpace="0.5em">
        {items.map(({ value }) => (
          <StyledControlLabel
            key={value}
            value={value}
            className={currentValue === value ? 'checked' : ''}
            control={<StyledRadio label />}
            label={value}
          />
        ))}
      </FlexFlow>
    </StyledRadioGroup>
  );
};

ContentPicker.defaultProps = {
  selectedItem: {
    value: '',
    label: '',
  },
};

ContentPicker.propTypes = {
  selectedItem: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default ContentPicker;
